// src/config/contactInfo.js
const contactInfo = {
    name: "Muhammad Asif",
    email: "chaudryasif2012@gmail.com",
    phone: "+43 688 642 81311",
    whatsapp: "+4368864281311", // used in wa.me link
    location: "Innsbruck, Austria",
  };
  
  export default contactInfo;
  